const mutations = {
  setNewness(state, data) {
    state.newnessEdit = data
  },
  setDeleteNewness(state, data) {
    state.newnessDelete = data
  }
}

export default mutations